<!--
 * @Description: 绑定角色
 * @Author: cooky
 * @Date: 2021-02-25 17:17:56
 * @LastEditors: cooky
 * @LastEditTime: 2021-04-12 09:58:31
-->
<template>
  <BasePop :title="$t('binding_roles')" :widthHelp="true">
    <div class="tip-orange">{{ $t('please_binding') }}</div>
    <div class="form-item role-form-item">
      <SInput class="role" :placeholder="$t('role_play_id')" v-model.trim="roleIdInput" />
    </div>
    <div class="form-item verify-form-item">
      <div class="verify-container">
        <div class="verify-control">
          <SInput class="verify-input" :placeholder="$t('input_verification_code')" v-model="verifyCode" />
          <s-button
            class="verify-btn"
            :timed="timed"
            @click="getVerifyCode"
            :loading="getCodeLoading"
          >
            <!-- :disabled="verifyBtnDiasbled" -->
            {{ this.$t('get_verification_code') }}
          </s-button>
        </div>
      </div>
    </div>
    <div class="tip-red" v-if="verifyCodeSended">{{ $t("verification_code_sended") }}</div>
    <s-button size="large" :disabled="bindBtnDisabled" @click="validateAndBindRole" :loading="loading">{{ $t('binding') }}</s-button>
  </BasePop>
</template>
<script>
import { sendBindRoleVerifyCode, bindRole } from '@/api'
import { mapState, mapMutations, mapGetters } from 'vuex'
import BasePop from './base'
import ServerRole from './ServerRoleForm'
import Store from '@/store'

export default {
  name: 'InfoBinding',
  async beforeRouteEnter (to, from, next) {
    if (!sessionStorage.token) {
      next({ name: 'ThirdPartChannel' })
    } else {
      await Store.dispatch('GetAllRoles')
      const { roleId, serverName } = sessionStorage
      const { serverRoleList } = Store.getters
      if (serverName && serverRoleList.find(item => item.server_name === serverName)) {
        next({ name: 'buying' })
      } else if (roleId) {
        next({ name: 'InfoBinding' })
      } else {
        next()
      }
    }
  },
  components: {
    BasePop,
    ServerRole
  },
  data () {
    return {
      loading: false,
      roleIdInput: '',
      verifyCode: '',
      verifyCodeId: '',
      timed: false,
      verifyCodeSended: false,
      verifyTimer: null,
      getCodeLoading: false
    }
  },
  computed: {
    ...mapState([
      'token',
      'lang'
    ]),
    ...mapGetters(['roleId', 'serverRoleList']),
    // verifyBtnDiasbled () {
    //   return this.roleIdInput === ''
    // },
    bindBtnDisabled () {
      return this.verifyCodeId === '' || this.verifyCode === '' || this.roleIdInput === ''
    }
  },
  watch: {
    // lang () {
    //   this.init()
    // }
  },
  created () {
    this.validateAndInit()
  },
  methods: {
    ...mapMutations([
      'SET_TOKEN',
      // 'SET_SERVER_NAME',
      // 'SET_ROLE_NAME',
      // 'SET_APP_ID',
      'SET_ROLE_Id'
    ]),
    validateAndInit () {
      // if (!this.token) {
      //   this.modal = this.$modal({
      //     content: () => {
      //       return (
      //         <div class="tip">
      //           <div class="text">
      //             {this.$t('login_over_time')}
      //           </div>
      //           <div class="ok-btn" onClick={this.toLogin.bind(this)}>
      //             {this.$t('ok')}
      //           </div>
      //         </div>
      //       )
      //     }
      //   })
      //   this.$router.replace({ name: 'ThirdPartChannel' })
      // } else {
      //   this.init()
      // }
    },
    // 判断是否已经绑定过角色，是则跳转区服选择
    // async init () {
    //   const { code, data } = await getServerAndRole()
    //   if (code === 0) {
    //     if (data.server_list && data.server_list.length > 0) {
    //       this.$store.commit('SET_SERVER_ROLE_LIST', data.server_list)
    //       this.$router.replace({ name: 'InfoBinding' })
    //     } else {
    //       this.$info({
    //         content: () => {
    //           return this.$t('please_bind_role_info')
    //         },
    //         okText: this.$t('ok')
    //       })
    //       this.$router.replace({ name: 'ThirdPartInfoBinding' })
    //     }
    //   }
    // },
    toLogin () {
      this.$router.replace({ path: '/thirdPartChannel' })
      this.modal.close()
    },
    getVerifyCode () {
      if (!this.roleIdInput) {
        this.$info({
          content: () => {
            return (
              <div>
                {this.$t('roles_id_err')}
              </div>
            )
          },
          okText: this.$t('ok')
        })
        return
      }
      clearTimeout(this.verifyTimer)
      this.getCodeLoading = true
      this.verifyTimer = setTimeout(async () => {
        const { code, data } = await sendBindRoleVerifyCode({
          logical_region_id: parseInt(process.env.VUE_APP_LOGICAL_REGION_ID),
          show_id: this.roleIdInput
        })
        this.getCodeLoading = false
        if (code === 0) {
          this.timed = true
          this.verifyCodeId = data.code_id
          this.verifyCodeSended = true
        }
        setTimeout(() => {
          this.timed = false
        })
      }, 500)
    },
    validateAndBindRole () {
      this.bindRole()
    },
    async bindRole () {
      const { code } = await bindRole({
        code_id: this.verifyCodeId,
        code: this.verifyCode
      })
      if (code === 0) {
        this.SET_ROLE_Id(this.roleIdInput)
        this.$router.replace({ path: '/infoBinding' })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .tip-orange {
    color:#e8691c;
    margin: 30px 0 46px;
  }
  .verify-input {
    width: 230px;
    // margin-right: 26px;
  }
  .role-form-item {
    margin-bottom: 24px;
  }
  .tip-red {
    color:#f7314e;
    margin: 35px 0 14px;
    text-align: center;
    font-size: 16px;
  }
  .verify-control {
    display: flex;
    justify-content: space-between;
  }
  .verify-form-item {
    margin-bottom: 35px;
  }
  @media screen and (max-width: 750px) {
    .tip-red {
      font-size: 2.4rem;
      margin: 4rem 0 1.8667rem;
    }
    .verify-input {
      width: 35rem;
    }
    .role-form-item {
      margin-bottom: 4.8rem;
    }
    .s-button {
      width: 34rem;
      height: 8.5333rem;
    }
    .tip-orange {
     margin: 4.5333rem 0 7.4667rem;
     font-size: 2.6667rem /* 20/7.5 */;
    }
  }
</style>
